/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/products/collect
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCollectionKey,
  ShopifyCollectKey,
  ShopifyCollectToCollectionKey,
  ShopifyCollectToProductKey,
  ShopifyCollectToShopKey,
  ShopifyProductKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// shopify collect ids moved from shopify dominion to gadget dominion in 2025-04
// in order to keep migrations from previous version to 2025-04 we hard code the id key to
// be the key that was deterministically generated in versions prior to 2025-01
export const ShopifyCollectIdKey = "ModelField-DataModel-Shopify-Collect-id";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCollectKey,
  "2022-01": {
    name: "Shopify Collect",
    fields: [
      {
        // Only Custom Collections are exposed
        name: "Custom Collection",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToCollectionKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "collection_id" } },
        configuration: {
          relatedModelKey: ShopifyCollectionKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "position" } },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToProductKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "product_id" } },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Sort Value",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "sort_value" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "rest_sublist_param",
      resource: "collect",
      parent: "customCollection",
      paramName: "collection_id",
      parentFieldIdentifier: "customCollectionId",
      modelKey: ShopifyCollectKey,
    },
  },
  "2025-04": {
    fields: [
      {
        // Only Custom Collections are exposed
        name: "Custom Collection",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToCollectionKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "collection_id", graphQLFieldKey: "collectionId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyCollectionKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        key: ShopifyCollectIdKey,
      },
      {
        name: "Position",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "position" } },
        isDeleted: true,
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToProductKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "product_id", graphQLFieldKey: "productId", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
        isDeleted: true,
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
        isDeleted: true,
      },
      {
        name: "Sort Value",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "sort_value" } },
        isDeleted: true,
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCollectToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "custom_sublist", parent: "collections", resource: "collects" },
  },
};

export const ShopifyCollect = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
